export class ConnectWebSocket {
  static readonly type = '[WebSocket] Connect';
}

export class DisconnectWebSocket {
  static readonly type = '[WebSocket] Disconnect';
}

export class WebSocketConnected {
  static readonly type = '[WebSocket] Connected';
}

export class WebSocketDisconnected {
  static readonly type = '[WebSocket] Disconnected';
}

export class WebSocketMessageReceived {
  static readonly type = '[WebSocket] Message Received';
  constructor(public payload: { type: string; payload: unknown }) {}
}

export class SendWebSocketMessage {
  static readonly type = '[WebSocket] Send Message';
  constructor(public payload: { type: string; payload: unknown }) {}
}

export class WebSocketError {
  static readonly type = '[WebSocket] Error';
  constructor(public message: string) {}
}
